(function(){
  // ===== KONFIG =====
  var CONTENT_SELECTORS = [
    '.article__content', '.js-article-content',
    'article .rte', '.blog-article__content',
    '.article .content', '.rte'
  ];
  var HEADINGS_SELECTOR = 'h2, h3'; // zmień np. na 'h2, h3, p strong' jeśli używasz strongów zamiast nagłówków
  var OFFSET = 100;                 // dopasuj do wysokości sticky headera

  // ===== HELPERS =====
  function findContent(){
    for (var i=0;i<CONTENT_SELECTORS.length;i++){
      var el = document.querySelector(CONTENT_SELECTORS[i]);
      if (el) return el;
    }
    return null;
  }
  function slugify(str){
    return String(str||'')
      .toLowerCase()
      .normalize('NFD').replace(/[\u0300-\u036f]/g,'') // usuń diakrytyki
      .replace(/<\/?strong>/g,'')                      // usuń ewentualne <strong> z RTE
      .replace(/&amp;/g,'and')
      .replace(/[^a-z0-9\s-]/g,'')
      .trim().replace(/\s+/g,'-').replace(/-+/g,'-');
  }
  function smoothScrollTo(el){
    var y = el.getBoundingClientRect().top + window.pageYOffset - OFFSET;
    window.scrollTo({ top: y, behavior: 'smooth' });
  }

  // ===== GŁÓWNA =====
  function buildTOC(){
    var content = findContent();
    if (!content) return false;

    var headings = content.querySelectorAll(HEADINGS_SELECTOR);
    if (!headings.length) return false;

    // host TOC: użyj istniejącego #toc lub wstaw przed pierwszym nagłówkiem
    var tocHost = document.getElementById('toc');
    if (!tocHost) {
      tocHost = document.createElement('div');
      tocHost.id = 'toc';
      var first = headings[0];
      (first && first.parentNode ? first.parentNode : content)
        .insertBefore(tocHost, first || content.firstChild);
    }

    // zbuduj listę
    var ul = document.createElement('ul');
    headings.forEach(function(h){
      if (!h.id) h.id = slugify(h.textContent || h.innerText || 'sekcja');
      var li = document.createElement('li');
      if (h.tagName.toLowerCase()==='h3') li.style.marginLeft='1rem';
      var a = document.createElement('a');
      a.href = '#'+h.id;
      a.textContent = (h.textContent || h.innerText || h.id).trim();
      li.appendChild(a);
      ul.appendChild(li);
    });

    tocHost.innerHTML = '<strong>Spis treści</strong>';
    tocHost.appendChild(ul);

    // ---- przewijanie + podświetlenie po kliknięciu / wejściu z hashem ----
    function go(hash){
      if (!hash) return;
      var id = decodeURIComponent(hash.replace(/^#/, ''));
      var t = document.getElementById(id);
      if (!t) return;

      // przewiń
      setTimeout(function(){
        smoothScrollTo(t);
        // podświetl po krótkiej chwili (gdy scroll dojedzie)
        setTimeout(function(){
          // jeśli wolisz mignąć całym wrapperem, podmień na: t.closest('.article__content') || t;
          var target = t;
          target.classList.remove('anchor-flash');
          void target.offsetWidth; // reset animacji
          target.classList.add('anchor-flash');
        }, 250);
      }, 30);
    }

    // kliknięcia w TOC
    tocHost.addEventListener('click', function(e){
      var a = e.target.closest('a[href^="#"]');
      if (!a) return;
      e.preventDefault();
      history.pushState(null, '', a.getAttribute('href'));
      go(a.getAttribute('href'));
    });

    // start z hashem + zmiany hasha (np. cofanie w historii)
    if (window.location.hash) go(window.location.hash);
    window.addEventListener('hashchange', function(){ go(window.location.hash); });

    return true;
  }

  // ===== BOOT + RETRY + OBSERVER =====
  function boot(){
    if (buildTOC()) return;
    var tries = 0, timer = setInterval(function(){
      if (buildTOC() || ++tries > 20) clearInterval(timer); // retry do ~3s
    }, 150);
    if ('MutationObserver' in window){
      var mo = new MutationObserver(function(){
        if (buildTOC()) mo.disconnect();
      });
      mo.observe(document.body, { childList:true, subtree:true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
